import React, { useEffect, useState } from "react";
import { SVGIcons, ImgIcons } from "../../Helpers/Common";
import { Link } from "react-router-dom";
import { SendNewletter } from "../../Model/Users";
import { ToastContainer, toast } from "react-toastify";

var SVGIcon = "";
var ImageData = "";

SVGIcons().then((resultData) => (SVGIcon = resultData));
ImgIcons().then((result) => (ImageData = result));

export const Footerdesk = () => {
  const [subscribe, setSubscibe] = useState("");
  const [enable, setEnable] = useState(true);
  function isValidEmail(email) {
    return /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
      email
    );
  }
  const subscribeBtn = () => {
    let data = {
      email: subscribe,
    };
    SendNewletter(data).then((res) => {
      if (JSON.parse(res.data).success == true) {
        setSubscibe("");
        toast("User subscribed successfully for newsletter", {
          position: "bottom-center",
          autoClose: 2000,
          hideProgressBar: true,
          closeButton: false,
          draggable: true,
          theme: "light",
          className: "toast-message-newsletter",
        });
      }
    });
  };
  useEffect(() => {
    if (isValidEmail(subscribe) == false) {
      setEnable(true);
    } else {
      setEnable(false);
    }
  }, [subscribe]);
  return (
    <>
      <ToastContainer />
      <footer className="dD-block">
        <section className="mb-0">
          {/* <div className="footer-search"> */}
          <div className="footer-searchArea">
            <div className="footer-searchMainArea">
              <div className="footer-searchLeftInn">
                <h5>Join the Tribe</h5>
                <p>Get the Doculetter</p>
              </div>
              <div className="footer-searchRightInn">
                <div className="formField">
                  <input
                    type="email"
                    name="password"
                    autoComplete="off"
                    placeholder="Email Address"
                    value={subscribe || ""}
                    onChange={(e) => setSubscibe(e.target.value)}
                  />
                  {/* <span class="temp34-clear">CLEAR</span> */}
                  {/* <div class="valid-msg">
                                <p>Showing Results for : amaz </p>
                            </div> */}
                  <button
                    type="submit"
                    id="sendEnquiryBtn"
                    className={enable ? "btn-black" : "btn-red"}
                    onClick={subscribeBtn}
                    disabled={enable}
                  >
                    SUBMIT
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="footer-searchRight" />
          {/* </div> */}
        </section>
        <section className="mb-0">
          {/* <div className="footer-nav"> */}
          <div className="footer-navArea">
            <div className="footer-navCol">
              <ul>
                <li>
                  {" "}
                  <h4>Company</h4>{" "}
                </li>
                <li>
                  {" "}
                  <Link to="/about-us">About Us</Link>
                </li>
                <li>
                  {" "}
                  <Link to="/faq">FAQ’s</Link>{" "}
                </li>
              </ul>
            </div>
            <div className="footer-navCol">
              <ul>
                <li>
                  {" "}
                  <h4>Support</h4>{" "}
                </li>
                <li>
                  {" "}
                  <Link to="/contact-us">Contact Us</Link>
                </li>
              </ul>
            </div>
            <div className="footer-navCol">
              <ul>
                <li>
                  {" "}
                  <h4>Legal</h4>{" "}
                </li>
                <li>
                  {" "}
                  <Link to="/terms">Terms Of Use</Link>{" "}
                </li>
                <li>
                  {" "}
                  <Link to="/privacy">Privacy Policy</Link>{" "}
                </li>
              </ul>
            </div>
            <div className="footer-navCol soc">
              <ul>
                <li>
                  {" "}
                  <h4>
                    {" "}
                    <img
                      src={ImageData["footer-img.png"]}
                      alt="DocuBay"
                      className="docuR"
                    />
                  </h4>{" "}
                </li>
              </ul>
              <ul className="social">
                <li>
                  {" "}
                  <a
                    href="https://www.facebook.com/ethiotelecom/"
                    target="_blank"
                  >
                    <img src={SVGIcon["fb.svg"]} alt="fb" />
                  </a>{" "}
                </li>
                <li>
                  {" "}
                  <a
                    href="https://www.instagram.com/ethiotelecom/"
                    target="_blank"
                  >
                    <img src={SVGIcon["insta.svg"]} alt="Insta" />
                  </a>{" "}
                </li>
                <li>
                  {" "}
                  <a
                    href="https://www.youtube.com/c/EthiotelecomETH/"
                    target="_blank"
                  >
                    <img src={SVGIcon["tube.svg"]} alt="You Tube" />
                  </a>{" "}
                </li>
                <li>
                  {" "}
                  <a
                    href="https://www.linkedin.com/company/ethio-telecom/"
                    target="_blank"
                  >
                    <img src={SVGIcon["in.svg"]} alt="In" />
                  </a>{" "}
                </li>
                <li>
                  {" "}
                  <a href="https://twitter.com/ethiotelecom/" target="_blank">
                    <img src={ImageData["twitter.png"]} alt="Tw" />
                  </a>{" "}
                </li>
              </ul>
              {/* <ul>
                <li>
                  <a
                    href="https://wa.me/919738274274?text=Hi"
                    target="_blank"
                    className="social-2"
                  >
                    <img
                      src={SVGIcon["whatsapp1.svg"]}
                      alt="whatsapp"
                      className="wp-img"
                    />{" "}
                    <span>Support</span>{" "}
                  </a>{" "}
                </li>
              </ul> */}
            </div>
          </div>
          {/* </div> */}
        </section>
        {/* <section className="mb-0">
          <div className="diff-platform">
            Available on many devices. Install the app now.
          </div>
          <div className="row footer-icon" id="desktop-footer-icon">
            <ul className="app-icon">
              <li>
                <a
                  target="_blank"
                  href="https://play.google.com/store/apps/details?id=com.epic.docubay"
                >
                  <img
                    src={SVGIcon["google-play.svg"]}
                    className="google-play-icon"
                    alt="DocuBay-Google-Play-Store"
                  />{" "}
                </a>
              </li>
              <li>
                <a
                  target="_blank"
                  href="https://apps.apple.com/in/app/docubay-watch-documentaries/id1458102898"
                >
                  <img
                    src={SVGIcon["app-store.svg"]}
                    className="google-play-icon"
                    alt="DocuBay-Apple-Store"
                  />{" "}
                </a>{" "}
              </li>
              <li>
                <img
                  src={SVGIcon["lg-tv.svg"]}
                  className="lg-tv-icon"
                  alt="DocuBay-TV-Store"
                />{" "}
              </li>
              <li>
                <img
                  src={SVGIcon["smart-tv.svg"]}
                  className="smart-tv-icon"
                  alt="DocuBay-Smart-TV"
                />{" "}
              </li>
              <li>
                <img
                  src={SVGIcon["apple-tv.svg"]}
                  className="apple-tv-icon"
                  alt="DocuBay-Apple-TV"
                />{" "}
              </li>
              <li>
                <img
                  src={SVGIcon["android-tv.svg"]}
                  className="android-tv-icon"
                  alt="DocuBay-Android-TV"
                />{" "}
              </li>
              <li>
                <img
                  src={SVGIcon["roku.svg"]}
                  className="roku-icon"
                  alt="DocuBay-ROKU"
                />{" "}
              </li>
              <li>
                <img
                  src={SVGIcon["chromecast.svg"]}
                  className="chromecast-icon"
                  alt="DocuBay-Chrome-Cast"
                />{" "}
              </li>
              <li>
                <img
                  src={SVGIcon["fire-tv.svg"]}
                  className="fire-tv-icon"
                  alt="DocuBay-Fire-TV"
                />{" "}
              </li>
              <li>
                <img
                  src={ImageData["mi-tv.png"]}
                  className="mi-tv-icon"
                  alt="DocuBay-MI-TV"
                />{" "}
              </li>
            </ul>
          </div>
        </section>*/}
        <section className="mb-0">
          <div className="footer-copyRArea">
            <div className="footer-copyLeft">
              &copy; {new Date().getFullYear()} Ethio telecom All Rights Reserved.</div>
          </div>
          {/* <div className="footer-copyRArea">
            <div className="footer-copyLeft footer-in10logo">
              An<img
                src={ImageData["in10log.png"]}
                className="In10logo"
                alt="In10"
              />Venture
            </div>
          </div> */}
        </section>
      </footer>
    </>
  );
};
